import { render, staticRenderFns } from "./BemVindoPortal.vue?vue&type=template&id=347f2b06&"
import script from "./BemVindoPortal.vue?vue&type=script&lang=js&"
export * from "./BemVindoPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports